// src/components/Profile/AffiliationsTab.jsx
import { Card, Col, Row, Empty, Tag, Typography } from "antd";
import { UsergroupAddOutlined, CheckCircleOutlined } from "@ant-design/icons";

const { Text } = Typography;

const AffiliationsTab = ({ institution }) => {
  const { affiliations = [] } = institution;

  if (affiliations.length === 0) {
    return <Empty description="No affiliations found." />;
  }

  return (
    <Row gutter={[16, 16]} className="pt-5 pb-4">
      {affiliations.map((item) => {
        const raw = (item.membership_status || "")
          .toString()
          .trim()
          .toLowerCase();
        const tagColor =
          raw === "active" ? "green" : raw === "inactive" ? "red" : "blue";

        return (
          <Col key={item.id} xs={24} sm={12} md={6}>
            <Card
              title={
                <div className="text-base font-semibold text-gray-800 flex items-center gap-2">
                  <UsergroupAddOutlined className="text-indigo-600" />
                  {item.organization_name || "Unnamed Organization"}
                </div>
              }
              className="border border-gray-200!"
            >
              <div className="space-y-3 text-gray-700 text-sm">
                <div className="flex items-start gap-2">
                  <CheckCircleOutlined className="text-green-600 mt-[3px]" />
                  <div>
                    <Text strong>Status:</Text>{" "}
                    <Tag color={tagColor} className="font-medium">
                      {item.membership_status || "N/A"}
                    </Tag>
                  </div>
                </div>
              </div>
            </Card>
          </Col>
        );
      })}
    </Row>
  );
};

export default AffiliationsTab;
